import React from 'react'
import './Project-Components.scss'
function Project() {
    return (
        <div className='w-full grid grid-cols-12 gap-10 bg-dark-shaded p-10 border-b-[1px] border-[#EC3A21] mb-10'>
            <div className="col-span-6">
                <div className='w-full project-containers h-[60vh] flex items-end'
                    style={{
                        backgroundImage: "url('/images/architectures/1.jpg')"
                    }}
                >
                    <div className=' project-header-containers px-[6%] py-[3%]'>
                        <h1 className='text-white monument-regular text-4xl '>
                            01
                        </h1>
                    </div>
                </div>
            </div>
            <div className="col-span-6 flex flex-col relative h-full justify-center">
                <h1 className='text-white tex-regular text-4xl'>PROEJCT NAME</h1>
                <br />
                <p className='text-white montserrat font-medium text-base opacity-80 p-5'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius ex, ab porro illo perferendis. Odit
                    , et? Obcaecati magni numquam maxime iusto tempora, sunt reprehenderit amet, nam, saepe deserunt deleniti.
                </p>
                {/* <p className='text-white tex-regular text-base opacity-80 p-5'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius ex, ab porro illo perferendis. Odit
                    , et? Obcaecati magni numquam maxime iusto tempora, sunt reprehenderit amet, nam, saepe deserunt deleniti.
                </p> */}
                <br />
                <button className="px-[30px] w-fit py-[5px] bg-[#ad2f1e] monument-regular font-light text-white">
                    VIEW PLAN ↗
                </button>
                <div className="absolute bottom-0 right-0 flex flex-col items-end w-fit ">
                    <div className='w-fit rotate-[-45deg]'>
                        <div className="flex flex-col w-fit center ">
                            <div className="main-red-bg w-[20px] h-[1px] "></div>
                            <div className="main-red-bg w-[10px] h-[1px] mt-[3px] "></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Project